'use client';

import { InfoCardMain } from '@sola/ark-skippy/organisms-cms/info-card/main/infoCard-main.tsx';
import type {
  ComponentBaseProps,
  FlexibleContentProps,
} from '@sola/schema/lib/schema.ts';

import { DepartureSpotlightCard } from '../../molecules/departure-spotlight-card/departure-spotlight-card.tsx';
import { useDepartureOverview } from './departure-overview.logic.ts';

type DepartureOverviewContentSlots = {
  infoCardContent?: FlexibleContentProps;
};

export type DepartureOverviewProps =
  ComponentBaseProps<DepartureOverviewContentSlots>;

export const DepartureOverview: React.FC<DepartureOverviewProps> = ({
  settings: _settings,
  contentSlots,
}) => {
  const content = useDepartureOverview(contentSlots?.infoCardContent);

  const hasInfoCardContent = Boolean(
    content?.title ||
    content?.subtitle ||
    content?.body ||
    content?.media ||
    content?.primaryCTA ||
    content?.secondaryCTA ||
    content?.tertiaryCTA ||
    content?.items?.length,
  );

  return (
    <div className="DepartureOverview flex w-full flex-col gap-comfy-xl">
      <DepartureSpotlightCard />
      {hasInfoCardContent && <InfoCardMain {...content} alt={false} />}
    </div>
  );
};
